interface HeroBadgeProps {
  text: string;
  linkText?: string;
  linkHref?: string;
  onLinkClick?: () => void;
}

export function HeroBadge({ text, linkText, linkHref = "#", onLinkClick }: HeroBadgeProps) {
  return (
    <div className="group/badge w-full max-w-[520px] backdrop-blur-[70px] rounded-[16px] bg-[rgba(239,240,243,0.09)] border border-white/30 hover:border-white/60 flex items-center py-2.5 pl-[11px] pr-[19px] gap-3 transition-all duration-300 hover:bg-[rgba(239,240,243,0.15)]">
      {/* Shield icon replacing gray placeholder */}
      <div className="w-[52px] h-[52px] lg:w-[64px] lg:h-[64px] rounded-[10px] bg-white/10 group-hover/badge:bg-white/[0.16] flex items-center justify-center shrink-0 transition-all duration-300">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          className="w-6 h-6 lg:w-7 lg:h-7 text-white transition-transform duration-300 group-hover/badge:scale-110"
        >
          <path
            d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 12l2 2 4-4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-[7px] flex-1 min-w-0">
        <p className="text-[14px] md:text-[16px] lg:text-[18px] tracking-[-0.04em] text-white leading-[1.4]">
          {text}
        </p>
        {linkText && (
          <a
            href={onLinkClick ? undefined : linkHref}
            onClick={onLinkClick ? (e) => { e.preventDefault(); onLinkClick(); } : undefined}
            className="group/link relative flex items-center gap-2 w-fit pb-1 cursor-pointer"
          >
            <span className="text-[14px] md:text-[18px] lg:text-[20px] tracking-[-0.04em] text-white">
              {linkText}
            </span>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              className="w-5 h-5 lg:w-6 lg:h-6 text-white transition-transform duration-300 group-hover/link:translate-x-1"
            >
              <path
                d="M5 12H19M19 12L13 6M19 12L13 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {/* Underline that reveals on hover */}
            <span className="absolute bottom-0 left-0 h-[1px] bg-white w-0 group-hover/link:w-full transition-all duration-300" />
          </a>
        )}
      </div>
    </div>
  );
}
